import Link from "@mui/material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}

function ExternalLink({ href, children }: ExternalLinkProps) {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noreferrer"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
    >
      {children}
      <OpenInNewIcon fontSize="small" />
    </Link>
  );
}

export { ExternalLink };
